import { Component, EventEmitter, Input, Output } from '@angular/core'
import { GenericLayer } from '../../../shared/model/layers/generic-layer'

@Component({
    selector: 'app-layer-group-detail',
    templateUrl: './layer-group-detail.component.html',
    styleUrls: ['./layer-group-detail.component.scss'],
})
export class LayerGroupDetailComponent {
    @Input()
    layers: GenericLayer[] | undefined | null

    @Input()
    title: string

    @Output()
    close = new EventEmitter<void>()

    opacityPercent = 100

    setLayerOpacity(newValue: number, oldValue: number): void {
        if (newValue === oldValue) return
        this.layers?.forEach(layer => {
            if (layer.opacityPercent) {
                layer.opacityPercent.setValue(newValue)
            }
        })
        this.opacityPercent = newValue
    }
}
